import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const submitContact = (data) =>
  api.post("/contact", data).then((r) => r.data);
export const submitPodcastQuestion = (data) =>
  api.post("/podcast/question", data).then((r) => r.data);
export const fetchGuestCalendar = () =>
  api.get("/guests/calendar").then((r) => r.data);
export const guestIcsUrl = (id) => `${API}/guests/${id}/calendar.ics`;
const VOTER_KEY = "atfq_voter";
export const voterId = () => {
  let v = localStorage.getItem(VOTER_KEY);
  if (!v) {
    v = (crypto.randomUUID?.() || `${Date.now()}-${Math.random()}`).slice(0, 48);
    localStorage.setItem(VOTER_KEY, v);
  }
  return v;
};
const voterHeaders = () => ({ headers: { "X-ATFQ-Voter": voterId() } });

export const fetchFeaturedVoices = () =>
  api.get("/voices/featured", voterHeaders()).then((r) => r.data);
export const fetchVoiceArchive = () =>
  api.get("/voices/archive", voterHeaders()).then((r) => r.data);
export const voteForVoice = (id) =>
  api.post(`/voices/${id}/vote`, null, voterHeaders()).then((r) => r.data);

export const TURNSTILE_REQUIRED = Boolean(
  process.env.REACT_APP_TURNSTILE_SITE_KEY
);

/** Normalise Axios/FastAPI error responses down to a user-facing string. */
export const extractApiError = (err, fallback = "Please try again.") => {
  const detail = err?.response?.data?.detail ?? err?.message;
  return typeof detail === "string" ? detail : fallback;
};
